let scriptPromise = null;

export function loadRecaptcha(siteKey) {
  if (!siteKey) return Promise.reject(new Error("missing site key"));
  if (window.grecaptcha) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    s.async = true;
    s.defer = true;
    s.onload = () => (window.grecaptcha ? resolve() : reject(new Error("recaptcha unavailable")));
    s.onerror = () => reject(new Error("could not load recaptcha"));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export async function getRecaptchaToken(siteKey, action) {
  await loadRecaptcha(siteKey);
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(siteKey, { action }).then(resolve).catch(reject);
    });
  });
}
